import {
  getComisionable,
  getNoComisionable,
  getMesComisiones,
  getSueldoBase,
  getTotalVentas,
  getTotalVentasMarcadas,
  getTotalVentasAgente,
  getCalculoComision,
  getComisionesAgente,
  checkAllComicion,
  checkComicion,
  pagarComicion,
  getComisionesPagadas
} from "../services/cotizacionService";
import { FormatoFecha } from "../utils/FormatFecha";

const dataInicial = {
  fechaFiltro: new Date(),
  comisionables: [],
  noComisionables: [],
  comisionesAgente: [],
  pagosAgente: [],
  meses: [],
  datos: [],
  calComision: {},
  pagoAgente: {
    FechaPago: '',
    cotizaciones: []
  },
  totVentas: 0,
  exito: 0,
  exitoPago: 0,
  agente: 'opcion',
  mes: 1,
  sueldoBase: { Valor_Parametro: '0' },
  resumenAgente: {
    totalVentas: 0,
    porcentaje: 0,
    comision: 0
  },
  resumenMarcado: {
    totalVentas: 0,
    porcentaje: 0,
    comision: 0
  }
}

const GET_RESUMENES = "GET_RESUMENES";
const GET_RESUMEN_AGENTE = "GET_RESUMEN_AGENTE";
const GET_COMISIONES = "GET_COMISIONES";
const GET_COMISIONABLES = "GET_COMISIONABLES";
const GET_NO_COMISIONABLES = "GET_NO_COMISIONABLES";
const GET_COMISIONES_AGENTE = "GET_COMISIONES_AGENTE";
const GET_COMISIONES_AGENTE_PAGADAS = "GET_COMISIONES_AGENTE_PAGADAS";
const GET_COMISIONES_AGENTE_FILTRO = "GET_COMISIONES_AFENTE_FILTRO"
const GET_MES_COMISIONES = "GET_MES_COMISIONES";
const GET_SUELDO_BASE = "GET_SUELDO_BASE";
const GET_TOTAL_VENTAS = "GET_TOTAL_VENTAS";
const GET_CALCULO_COMISION = "GET_CALCULO_COMISION";
const POST_PAGAR_COMISION = "POST_PAGAR_COMISION";
const POST_MARCAR_TODAS_COMICION = "POST_MARCAR_TODAS_COMICION";
const POST_MARCAR_COMICION = "POST_MARCAR_COMICION";
const CLEAR_COTIZACION_ALL = "CLEAR_COTIZACION_ALL";
const SET_AGENTE = "SET_AGENTE";
const SET_MES = "SET_MES";
const SET_AGENTE_PAGO = "SET_AGENTE_PAGO";


export default function cotizacionReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_RESUMENES:
      return { ...state, sueldoBase: action.payload.sueldoBase, resumenAgente: action.payload.resumenAgente, resumenMarcado: action.payload.resumenMarcado }
    case GET_RESUMEN_AGENTE:
      return { ...state, resumenAgente: action.payload.resumenAgente }
    case GET_COMISIONES:
      return {
        ...state, comisionables: action.payload.comisionables, noComisionables: action.payload.noComisionables,
        sueldoBase: action.payload.sueldoBase, resumenAgente: action.payload.resumenAgente,
        meses: action.payload.meses, datos: action.payload.datos
      }
    case GET_COMISIONABLES:
      return { ...state, comisionables: action.payload.comisionables }
    case GET_NO_COMISIONABLES:
      return { ...state, noComisionables: action.payload.noComisionables }
    case GET_COMISIONES_AGENTE_PAGADAS:
      return { ...state, pagosAgente: action.payload.pagosAgente }
    case GET_COMISIONES_AGENTE:
      return { ...state, comisionesAgente: action.payload.comisionesAgente }
    case GET_COMISIONES_AGENTE_FILTRO:
      return { ...state, comisionesAgente: action.payload.comisionesAgente, fechaFiltro: action.payload.fechaFiltro }
    case GET_MES_COMISIONES:
      return { ...state, meses: action.payload.meses, datos: action.payload.datos }
    case GET_SUELDO_BASE:
      return { ...state, sueldoBase: action.payload.sueldoBase }
    case GET_TOTAL_VENTAS:
      return { ...state, totVentas: action.payload.totVentas }
    case GET_CALCULO_COMISION:
      return { ...state, calComision: action.payload.calComision }
    case POST_PAGAR_COMISION:
      return { ...state, exitoPago: action.payload.exitoPago, comisionesAgente: action.payload.comisionesAgente }
    case POST_MARCAR_TODAS_COMICION:
      return { ...state, exito: action.payload.exito, comisionesAgente: action.payload.comisionesAgente }
    case POST_MARCAR_COMICION:
      return { ...state, exito: action.payload.exito, comisionesAgente: action.payload.comisionesAgente }
    case CLEAR_COTIZACION_ALL:
      return { ...state, sueldoBase: action.payload.sueldoBase, resumenAgente: action.payload.resumenAgente, resumenMarcado: action.payload.resumenMarcado }
    case SET_AGENTE:
      return { ...state, agente: action.payload.agente }
    case SET_MES:
      return { ...state, mes: action.payload.mes }
    case SET_AGENTE_PAGO:
      return { ...state, resumenMarcado: action.payload.resumenMarcado, pagoAgente: action.payload.pagoAgente }
    default:
      return state;
  }
}

export const obtenerComisiones = () => async (dispatch) => {
  try {
    const comisionables = await getComisionable();
    const noComisionables = await getNoComisionable();
    const sueldoBase = await getSueldoBase();
    const totalVentas = await getTotalVentas();
    const calculo = await getCalculoComision(totalVentas)
    const comisiones = await getMesComisiones();

    const meses = []
    const datos = []
    comisiones.map((row, index) => {
      meses.push(row.Nombre);
      datos.push(row.MontoVenta);
      return null
    })
    var resumenAgente = {
      totalVentas: totalVentas,
      porcentaje: calculo.Porcentaje,
      comision: calculo.Comision
    }
    dispatch({
      type: GET_COMISIONES,
      payload: {
        sueldoBase: sueldoBase,
        resumenAgente: resumenAgente,
        comisionables: comisionables,
        noComisionables: noComisionables,
        meses: meses,
        datos: datos
      },
    });
    return comisionables;
  } catch (error) {
    return error;
  }
};


export const obtenerResumenes = () => async (dispatch, getState) => {
  const agente = getState().cotizacion.agente

  const sueldoBase = await getSueldoBase()
  const totalVentas = await getTotalVentasAgente(agente)
  const calculo = await getCalculoComision(totalVentas)

  const totalVentasMarcado = await getTotalVentasMarcadas(agente)
  const calculoMarcado = await getCalculoComision(totalVentasMarcado)

  var resumenAgente = {
    totalVentas: totalVentas,
    porcentaje: calculo.Porcentaje,
    comision: calculo.Comision
  }

  var resumenMarcado = {
    totalVentas: totalVentasMarcado,
    porcentaje: calculoMarcado.Porcentaje,
    comision: calculoMarcado.Comision
  }
  dispatch({
    type: GET_RESUMENES,
    payload: {
      sueldoBase: sueldoBase,
      resumenAgente: resumenAgente,
      resumenMarcado: resumenMarcado
    },
  });
  return resumenAgente;
}

export const obtenerResumenAgente = (agente) => async (dispatch) => {
  const sueldoBase = await getSueldoBase();
  const totalVentas = await getTotalVentasAgente(agente);
  const calculo = await getCalculoComision(totalVentas)
  var resumenAgente = {
    sueldoBase: sueldoBase,
    totalVentas: totalVentas,
    porcentaje: calculo.Porcentaje,
    comision: calculo.Comision
  }
  dispatch({
    type: GET_RESUMEN_AGENTE,
    payload: {
      resumenAgente: resumenAgente
    },
  });
  return resumenAgente;
}

export const obtenerComisionable = () => async (dispatch) => {
  try {
    const cotizaciones = await getComisionable();
    dispatch({
      type: GET_COMISIONABLES,
      payload: {
        comisionables: cotizaciones
      },
    });
    return cotizaciones;
  } catch (error) {
    return error;
  }
};

export const obtenerNoComisionable = () => async (dispatch) => {
  try {
    const cotizaciones = await getNoComisionable();
    dispatch({
      type: GET_NO_COMISIONABLES,
      payload: {
        noComisionables: cotizaciones,
      },
    });
    return cotizaciones;
  } catch (error) {
    return error;
  }
};

export const obtenerComisionesAgente = () => async (dispatch, getState) => {
  const { agente, fechaFiltro } = getState().cotizacion
  return getComisionesAgente({ agente, fechaFiltro: FormatoFecha({ date: fechaFiltro, formato: "MMyyyy" }) }).then(Response => {
    dispatch({
      type: GET_COMISIONES_AGENTE,
      payload: {
        comisionesAgente: Response,
      },
    })
    return Response
  }).catch(Error => {
    return Error;
  })
}
export const obtenerComisionesFiltro = ({ fechaFiltro }) => async (dispatch, getState) => {
  const { agente } = getState().cotizacion
  return getComisionesAgente({ agente, fechaFiltro: FormatoFecha({ date: fechaFiltro, formato: "MMyyyy" }) }).then(Response => {
    dispatch({
      type: GET_COMISIONES_AGENTE_FILTRO,
      payload: {
        comisionesAgente: Response,
        fechaFiltro: fechaFiltro
      },
    })
    return Response
  }).catch(Error => {
    return Error;
  })
}


export const obtenerComisionesAgentePagadas = () => async (dispatch, getState) => {
  try {
    const agente = getState().cotizacion.agente
    const mes = getState().cotizacion.mes
    const pagosAgente = await getComisionesPagadas(agente, mes);
    dispatch({
      type: GET_COMISIONES_AGENTE_PAGADAS,
      payload: {
        pagosAgente: pagosAgente
      },
    });
    return pagosAgente;
  } catch (error) {
    return error;
  }
};

export const obtenerMesComisionable = () => async (dispatch) => {
  try {
    const comisiones = await getMesComisiones();
    const meses = []
    const datos = []
    comisiones.map((row, index) => {
      meses.push(row.Nombre);
      datos.push(row.MontoVenta);
      return null
    })
    dispatch({
      type: GET_MES_COMISIONES,
      payload: {
        meses: meses,
        datos: datos
      },
    });
    return comisiones;
  } catch (error) {
    return error;
  }
};

export const obtenerSueldoBase = () => async (dispatch) => {
  try {
    const sueldoBase = await getSueldoBase();
    dispatch({
      type: GET_SUELDO_BASE,
      payload: {
        sueldoBase: sueldoBase,
      },
    });
    return sueldoBase;
  } catch (error) {
    return error;
  }
};

export const obtenerTotalVentas = () => async (dispatch) => {
  try {
    const totalVentas = await getTotalVentas();
    dispatch({
      type: GET_TOTAL_VENTAS,
      payload: {
        totVentas: totalVentas,
      },
    });
    return totalVentas;
  } catch (error) {
    return error;
  }
};

export const obtenerTotalVentasAgente = (agente) => async (dispatch) => {
  try {
    const totalVentas = await getTotalVentasAgente(agente);
    dispatch({
      type: GET_TOTAL_VENTAS,
      payload: {
        totVentas: totalVentas,
      },
    });
    return totalVentas;
  } catch (error) {
    return error;
  }
};

export const obtenerCalculoComision = (total) => async (dispatch) => {
  try {
    const calculoComision = await getCalculoComision(total);
    dispatch({
      type: GET_CALCULO_COMISION,
      payload: {
        calComision: calculoComision,
      },
    });
    return calculoComision;
  } catch (error) {
    return error;
  }
};

export const marcarTodasComicion = (marcado) => async (dispatch, getState) => {
  const {agente, fechaFiltro} = getState().cotizacion
  var payload = {
    marcado: marcado,
    agente: agente,
    fecha: FormatoFecha({date: fechaFiltro, formato: "MMyyyy"})
  }
  const exito = await checkAllComicion({ payload });
  const comisionesAgente = await getComisionesAgente({agente, fechaFiltro: FormatoFecha({date: fechaFiltro, formato: "MMyyyy"})});
  dispatch({
    type: POST_MARCAR_TODAS_COMICION,
    payload: {
      exito: exito,
      comisionesAgente: comisionesAgente
    },
  });
  return exito;
}

export const marcarComicion = (idCotizacion, marcado) => async (dispatch, getState) => {
  const {agente, fechaFiltro} = getState().cotizacion
  var payload = {
    marcado: marcado,
    IdCotizacion: idCotizacion
  }
  const exito = await checkComicion({ payload });
  const comisionesAgente = await getComisionesAgente({agente, fechaFiltro: FormatoFecha({date: fechaFiltro, formato: "MMyyyy"})});
  dispatch({
    type: POST_MARCAR_COMICION,
    payload: {
      exito: exito,
      comisionesAgente: comisionesAgente,
    },
  });
  return exito;
}

export const pagarComision = (marcado) => async (dispatch, getState) => {
  const {agente, fechaFiltro} = getState().cotizacion
  var payload = {
    marcado: marcado,
    agente: agente
  }
  const exitoPago = await pagarComicion({ payload });
  const comisionesAgente = await getComisionesAgente({agente, fechaFiltro: FormatoFecha({date: fechaFiltro, formato: "MMyyyy"})});
  dispatch({
    type: POST_PAGAR_COMISION,
    payload: {
      exitoPago: exitoPago,
      comisionesAgente: comisionesAgente,
    },
  });
  return exitoPago;
}

export const valorAgente = (agente) => (dispatch) => {
  dispatch({
    type: SET_AGENTE,
    payload: {
      agente: agente
    },
  });
};

export const valorMes = (mes) => (dispatch) => {

  dispatch({
    type: SET_MES,
    payload: {
      mes: mes
    },
  });
};

export const valorPagoAgente = (pagoAgente) => (dispatch) => {
  var resumenMarcado = {
    totalVentas: pagoAgente.TotalVenta,
    porcentaje: pagoAgente.PorcentajeComision,
    comision: pagoAgente.ComisionMes
  }
  dispatch({
    type: SET_AGENTE_PAGO,
    payload: {
      pagoAgente: pagoAgente,
      resumenMarcado: resumenMarcado
    },
  });
};

export const clearState = () => (dispatch) => {
  dispatch({
    type: CLEAR_COTIZACION_ALL,
    payload: {
      pagoAgente: {
        FechaPago: '',
        cotizaciones: []
      },
      sueldoBase: { Valor_Parametro: '0' },
      resumenAgente: {
        totalVentas: 0,
        porcentaje: 0,
        comision: 0
      },
      resumenMarcado: {
        totalVentas: 0,
        porcentaje: 0,
        comision: 0
      }
    },
  });
};